var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-policy",domProps:{"innerHTML":_vm._s(_vm.$t('company.PRIVACY_POLICY_BODY'))}})
}
var staticRenderFns = []

export { render, staticRenderFns }